import { cn } from "@/lib/utils"

/** 1:1 Port von admin/templates.py:.tbl-wrap + table. */
export interface Column<T> {
  key: string
  header: string
  align?: "left" | "right" | "center"
  render: (row: T) => React.ReactNode
  width?: string
}

export function DataTable<T>({
  rows,
  columns,
  emptyText = "Keine Eintraege",
  onRowClick,
  rowKey,
}: {
  rows: T[]
  columns: Column<T>[]
  emptyText?: string
  onRowClick?: (row: T) => void
  rowKey: (row: T) => string | number
}) {
  return (
    <div className="pp-tbl-wrap">
      <table>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                style={{
                  ...(col.width ? { width: col.width } : {}),
                  textAlign: col.align === "right" ? "right" : col.align === "center" ? "center" : "left",
                }}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center", color: "var(--text-muted)", padding: 32 }}>
                {emptyText}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr
                key={rowKey(row)}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={cn(onRowClick && "cursor-pointer")}
              >
                {columns.map((col) => (
                  <td
                    key={col.key}
                    style={{
                      textAlign: col.align === "right" ? "right" : col.align === "center" ? "center" : "left",
                    }}
                  >
                    {col.render(row)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
